import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCursorEditor({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M15 4v8l-7 4-7-4V4l7-4 7 4zM2 4.58v6.839l6 3.429V8L2.007 4.575 2 4.58zm7.008 9.69L14 11.42V5.714L9.008 14.27zM9 7.42v4.88L13.259 5H4.766L9 7.42zM3.015 4h9.97L8 1.151 3.015 4z"/>
        </svg>
    );
}

export default IconCursorEditor;
